import React from 'react'

import { useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import { useDialogStore } from '@stores/dialog.store'
import { GACategory } from '@utils/google-analytics'
import GoogleTagManager from '@utils/gtm/google-tag-manager'

interface Props {
  title: string
  action: string
  permission?: string
  name?: string
}

const MustBePremiumDialog: React.FC<Props> = ({
  title,
  action,
  name = 'must_be_premium',
  permission,
}: Props) => {
  const { t } = useTranslation()
  const closeDialog = useDialogStore((s) => s.closeDialog)

  const upgrade = (): void => {
    GoogleTagManager.trackLegacyEvent(GACategory.CONVERSION, 'upgrade', permission)
    closeDialog(name)
    window.location.href = '/plans'
  }

  return (
    <Dialog
      name={name}
      title={title}
      maxWidth={400}
      onOpen={() =>
        GoogleTagManager.trackLegacyEvent(GACategory.CONVERSION, 'upgrade_prompt', permission)
      }>
      <p className="whitespace-normal">{t('messages.mustBePremium', { action })}</p>
      <div className="flex flex-row w-full justify-end mt-4">
        <button
          title={t('action.cancel')}
          onClick={() => closeDialog(name)}
          className="btn btn-secondary ml-3">
          {t('action.cancel')}
        </button>
        <button
          type="button"
          title={t('action.upgrade')}
          onClick={upgrade}
          className="btn btn-primary ml-3">
          {t('action.upgrade')}
        </button>
      </div>
    </Dialog>
  )
}

export default MustBePremiumDialog
